import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { SearchTeam } from '../../00_modules/disposition/models';
import { ResetTeamSearch, SetTeamSearch, SetTeamSearchResult } from '../action/team-search.action';

const initialTeamSearchState = {
    searching: false,
    searchTerm: '',
    searchResult: [],
};

export interface TeamSearchStateModel {
    searching: boolean;
    searchTerm: string;
    searchResult: SearchTeam[];
}
@State<TeamSearchStateModel>({
    name: 'teamSearch',
    defaults: initialTeamSearchState,
})
@Injectable()
export class TeamSearchState {
    @Selector()
    static getTeamSearchResult(state: TeamSearchStateModel) {
        return state.searchResult;
    }

    @Selector()
    static getIsTeamSearching(state: TeamSearchStateModel) {
        return state.searching;
    }

    @Selector()
    static getTeamSearchTerm(state: TeamSearchStateModel) {
        return state.searchTerm;
    }

    @Action(SetTeamSearch)
    setTeamSearch(ctx: StateContext<TeamSearchStateModel>, action: SetTeamSearch) {
        if (action.searchTerm === '') {
            ctx.setState(initialTeamSearchState);
        } else {
            ctx.setState({
                searching: true,
                searchTerm: action.searchTerm,
                searchResult: [],
            });
        }
    }

    @Action(SetTeamSearchResult)
    setTeamSearchResult(ctx: StateContext<TeamSearchStateModel>, action: SetTeamSearchResult) {
        ctx.patchState({
            searching: false,
            searchResult: action.searchResult,
        });
    }

    @Action(ResetTeamSearch)
    resetTeamSearch(ctx: StateContext<TeamSearchStateModel>) {
        ctx.setState(initialTeamSearchState);
    }
}
